import client from './client';

export const authKeys = {
  all: ['auth'] as const,
  me: ['auth', 'me'] as const,
};

export interface AuthCenter {
  id: number;
  name: string;
  is_kumon: boolean;
}

export interface AuthUser {
  id: number;
  name: string;
  username: string;
  role: 'system' | 'center_admin' | 'teacher' | 'staff';
  center: AuthCenter | null;
  permissions: string[];
}

export async function login(
  username: string,
  password: string
): Promise<AuthUser> {
  const { data } = await client.post<AuthUser>('/api/v1/login', {
    username,
    password,
  });
  return data;
}

export async function logout(): Promise<void> {
  await client.post('/api/v1/logout');
}

export async function getCurrentUser(): Promise<AuthUser> {
  const { data } = await client.get<AuthUser>('/api/v1/me');
  return data;
}
